export enum TopicOpenType {
  BudgetDistribution,
  Content,
  TafDialg,
  Allocation,
  FinalIncumbent,
  HeadcountActions
}
